import * as React from "react";
import { Tooltip } from "@mui/material";

const pad = (n) => String(n).padStart(2, "0");
const fmt = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(ss)}` : `${pad(m)}:${pad(ss)}`;
};

export const CustomActionRender = ({ action }) => {
  const { team, jersey, name, eventLabel, catLabel, color, start } = action;
  const tooltip = (
    <span style={{ fontSize: 11, lineHeight: 1.5 }}>
      <b>{catLabel} — {eventLabel}</b>
      <br />
      {name ? `${name} ` : ""}#{jersey || "?"} · Team {team}
      <br />
      {fmt(start)}
    </span>
  );

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <div
        className="custom-action-box"
        style={{
          width: "100%",
          minWidth: 6,
          backgroundColor: color || "#3f51b5",
          borderRadius: 3,
          height: "70%",
          marginTop: "5%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 700,
          fontSize: 8,
          cursor: "pointer",
          overflow: "hidden",
          boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
          border: `1px solid ${team === "A" ? "#1C64F2" : "#F97316"}`,
        }}
      >
        {jersey ? `#${jersey}` : ""}
      </div>
    </Tooltip>
  );
};
